import { IStorageService } from "../StorageService";
import { StorageConstants } from "../../common/Constants";
import { IHttpService } from "../HttpService";
import { IPasswordResetCredentials } from "../../model/authentication/PasswordResetCredentials";
import ApplicationError from "../error/ApplicationError";

let loggedIn: boolean | undefined = undefined;
let username: string = "";

export interface ICredentialService {
  setUsername(value: string): void;
  getUsername(): string;
  setLoggedIn(value: boolean): Promise<void>;
  getLoggedIn(): Promise<boolean>;
  setLanguage(value: string): Promise<void>;
  getLanguage(): Promise<string>;
  resetPassword(
    credentials: IPasswordResetCredentials,
    language: string
  ): Promise<any>;
  confirmPassword(userId: string, code: string, language: string): Promise<any>;
}

const CredentialService = ({
  storageService,
  httpService
}: {
  storageService: IStorageService;
  httpService: IHttpService;
}): ICredentialService => {
  const _storageService: IStorageService = storageService;
  const _http: IHttpService = httpService;
  const _baseUrl: string = "/api/credentials";
  const _reset: string = "reset";
  const _confirm: string = "confirm";

  return {
    setUsername(value: string) {
      username = value;
    },
    getUsername() {
      return username;
    },
    async setLoggedIn(value: boolean) {
      loggedIn = value;
      _storageService.save(StorageConstants.LOGGED_IN, value);
    },
    async getLoggedIn() {
      if (loggedIn === undefined) {
        let value = await _storageService.get(StorageConstants.LOGGED_IN);
        loggedIn = value === "true";
      }
      return loggedIn;
    },
    async getLanguage() {
      return _storageService.get(StorageConstants.LANGUAGE);
    },

    async setLanguage(value: string) {
      _storageService.save(StorageConstants.LANGUAGE, value);
    },
    async resetPassword(
      credentials: IPasswordResetCredentials,
      language: string
    ) {
      const path = _http.buildPath(_baseUrl, _reset);
      try {
        const response = await _http.post(path, {
          form: true,
          query: {
            username: credentials.username,
            email: credentials.email,
            phone: credentials.phone,
            language: language.toUpperCase()
          }
        });
        return _http.toText(response);
      } catch (e: any) {
        throw ApplicationError({ ...e, handled: true });
      }
    },
    async confirmPassword(userId: string, code: string, language: string) {
      const path = _http.buildPath(_baseUrl, _confirm);
      try {
        const response = await _http.post(path, {
          form: true,
          query: {
            userId: userId,
            code: code,
            language: language.toUpperCase()
          }
        });
        return _http.toText(response);
      } catch (e: any) {
        throw ApplicationError({ ...e, handled: true });
      }
    }
  };
};

export default CredentialService;
